module.exports = __webpack_public_path__ + "img/nexi.266ef99a.png";